export default __webpack_public_path__ + "static/media/night.cc9b9fc2.svg";